import React from 'react';
import { Link } from 'react-router-dom';
import { CiCalendarDate } from "react-icons/ci";
import './Rule.css';
import {formatISO9075} from 'date-fns';
import { CiEdit } from "react-icons/ci";


function Rule(props) {
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  return (
    <>
    <div className='ruleCard'>
                    <div className='timeR'>
                    <div>
                    <CiCalendarDate />
                    <time>{formatISO9075(new Date(props.createAt))}</time>
                    </div>
                    {isLoggedIn && (
                         <>
                         <div className='ruleeditBtn'>
                        <Link to={`/editrule/${props.id}`} target='_top'><CiEdit /></Link>
                        </div>
                         </>
                       )}
                    </div>
                    <p>{props.ruleText}</p>
                    <div className='ruleInfo'>
                        <div>
                        <span>القانون:</span>
                        <span>{props.lawType}</span>
                        </div>
                        <div>
                        <span>قرار:</span>
                        <span>{props.lawYear}</span>
                        </div>
                        <div>
                        <span>المصدر:</span>
                        <span>{props.lawRef}</span>
                        </div>
                    </div>
                </div>
    </>
  )
}

export default Rule;